<template>
  <v-app class="larapress-app">
    <slot name="overlays" />
  <v-main :id="id">
    <v-app-bar color="rgba(84, 84, 84, 0.74)" app dense dark>
      <v-app-bar-nav-icon @click="drawer = true" />
      <v-toolbar-title>{{ barTitle }}</v-toolbar-title>
      <v-spacer />
      <v-menu offset-y dark>
        <template #activator="{ on }">
          <v-btn small rounded outlined :color="profileComplete ? 'green' : 'warning'"
            class="my-auto ms-1 no-letter-spacing" v-on="on">
            <span class="white--text">{{ userNameString }}</span>
            <v-avatar :color="profileComplete ? 'green' : 'warning'" size="32px" class="ms-2">
              <img v-if="userAvatar" alt="Avatar" :src="userAvatar" />
              <v-icon v-if="!userAvatar" color="white" small>mdi-face-recognition</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="link in links" :key="link.href" justify="space-between" :href="link.href">
            <v-icon>{{ link.icon }}</v-icon>
            <v-list-item-title class="mx-10">
              {{ link.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" temporary right fixed style="min-width: 300px">
      <AdminLinks :id="`${id}-links`" :groups="userGroups" />
    </v-navigation-drawer>

    <v-card>
      <v-card-text>
        <vuetify-formjson v-model="formModel" v-bind="this[this.getFormSchemaPropName()]" />
      </v-card-text>
    </v-card>
  </v-main>
  </v-app>
</template>

<script>
import FormJSONRenderer from "../Lib/vuetify-formjson/Fields/FormJSONBuilder/generator";
import AdminLinks from "../components/AdminLinks.vue";

export default {
  name: "PageTemplateAdminBar",
  components: {
    AdminLinks,
  },
  mixins: [FormJSONRenderer],
  props: {
    id: String,
    options: {
      type: [Object, Array],
      default: () => ({}),
    },
    sources: {
      type: Array,
      default: () => [],
    },
    body: {
      type: Object,
      default: () => ({
        schema: {},
        code: "",
        values: {},
      }),
    },
  },
  data() {
    return {
      drawer: false,
      groups: [
        {
          id: "accounts",
          icon: "mdi-account-box-multiple",
          title: "حساب‌های کاربری",
          links: [
            {
              id: "users",
              title: "کاربران",
              icon: "mdi-account",
              group: "accounts",
              extras: [
                {
                  icon: "mdi-web-clock",
                  id: "online",
                  title: "کاربران آنلاین",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-sale",
                  title: "گزارش فروش پشتیبان‌ها",
                  id: "sales",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش کاربران",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت کاربر جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "roles",
              title: "نقش ها",
              icon: "mdi-account-question",
              group: "accounts",
            },
            {
              id: "domains",
              title: "دامنه ها",
              icon: "mdi-domain",
              group: "accounts",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت نقش جدید",
                  color: "green lighten-3",
                },
              ],
            },
          ],
        },
        {
          id: "content",
          icon: "mdi-offer",
          title: "محتوای سایت",
          links: [
            {
              id: "forms",
              title: "فرم ها",
              icon: "mdi-clipboard-arrow-right",
              group: "content",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت فرم جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "form-entries",
              title: "فرم های پر شده",
              group: "content",
              icon: "mdi-clipboard-check-multiple",
              extras: [],
            },
            {
              id: "pages",
              title: "صفحات سایت",
              group: "content",
              icon: "mdi-file-document",
              extras: [
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش صفحات سایت",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت صفحه جدید در سایت",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "page-schemas",
              title: "قالب صفحات سایت",
              group: "content",
              icon: "mdi-file-document",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت قالب جدید در سایت",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "filters",
              title: "فیلترهای سایت",
              group: "content",
              icon: "mdi-air-filter",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "file-uploads",
              title: "فایل‌های ارسالی",
              icon: "mdi-file",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ارسال فایل جدید",
                  color: "green lighten-3",
                },
              ],
            },
          ],
        },
        {
          id: "products",
          icon: "mdi-widgets",
          title: "محصولات",
          links: [
            {
              id: "products",
              title: "محصولات",
              group: "products",
              icon: "mdi-widgets",
              extras: [
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش محصولات",

                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت محصول جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "product-categories",
              title: "دسته بندی محصولات",
              icon: "mdi-selection-drag",
              group: "products",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت دسته بندی محصول جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "product-types",
              title: "انواع محصولات",
              group: "products",
              title: "ثبت نوع محصول جدید",
              icon: "mdi-widgets-outline",
            },
          ],
        },
        {
          id: "contacts",
          icon: "mdi-contacts",
          title: "تماس و پشتیبانی",
          links: [
            {
              id: "sms-gateways",
              title: "درگاه‌های پیامکی",
              group: "contacts",
              icon: "mdi-cellphone-basic",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت درگاه پیامکی جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "sms-messages",
              title: "پیامک ها",
              group: "contacts",
              icon: "mdi-cellphone-arrow-down",
              extras: [
                {
                  icon: "mdi-send",
                  id: "send",
                  title: "ارسال پیامک جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "notifications",
              title: "اعلان‌ها",
              icon: "mdi-shield-alert",
              group: "contacts",
              extras: [
                {
                  icon: "mdi-send",
                  id: "send",
                  title: "ارسال اعلان جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "phone-numbers",
              title: "شماره های ثبت شده",
              group: "contacts",
              icon: "mdi-cellphone-text",
            },
          ],
        },
        {
          id: "ecommerce",
          icon: "mdi-credit-card-settings",
          title: "تجارت آنلاین",
          links: [
            {
              id: "bank-gateways",
              title: "درگاه‌های بانکی",
              group: "ecommerce",
              icon: "mdi-bank",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت درگاه بانکی جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "bank-gateway-transactions",
              title: "تراکنش های بانک",
              group: "ecommerce",
              icon: "mdi-bank-transfer",
              extras: [
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش تراکنش‌های بانک",
                  color: "cyan lighten-3",
                },
              ],
            },
            {
              id: "carts",
              title: "سبد های خرید",
              icon: "mdi-cart",
              group: "ecommerce",
              extras: [
                {
                  icon: "mdi-dolly",
                  id: "installments",
                  permission: "carts.view",
                  title: "اقساط پرداخت نشده",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش سبد‌های خرید",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت سبد‌ خرید جدید",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "wallet-transactions",
              title: "تراکنش های کیف پول",
              icon: "mdi-cart-arrow-right",
              group: "ecommerce",
              extras: [
                {
                  icon: "mdi-chart-pie",
                  id: "reports",
                  title: "گزارش کیف پول کاربران",
                  color: "cyan lighten-3",
                },
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت رکورد جدید در کیف پول",
                  color: "green lighten-3",
                },
              ],
            },
            {
              id: "gift-codes",
              title: "کد هدیه",
              icon: "mdi-gift",
              group: "ecommerce",
              extras: [
                {
                  icon: "mdi-plus",
                  id: "create",
                  title: "ثبت کد هدیه جدید",
                  color: "green lighten-3",
                },
              ],
            },
          ],
        },
        {
          id: "e-learning",
          icon: "mdi-cast-education",
          title: "آموزش الکترونیک",
          links: [
            {
              icon: "mdi-clipboard-file",
              id: "taklif-entries",
              title: "تکالیف",
              color: "cyan lighten-3",
              href: "taklif-entries",
              permission: "form-entries.view",
            },
            {
              icon: "mdi-clipboard-list",
              id: "azmoon-entries",
              title: "پاسخنامه آزمون",
              color: "cyan lighten-3",
              href: "azmoon-entries",
              permission: "form-entries.view",
            },
            {
              icon: "mdi-clipboard-check",
              id: "presence-entries",
              title: "حضور و غیاب کلاس آفلاین",
              color: "cyan lighten-3",
              href: "presence-offline-entries",
              permission: "form-entries.view",
            },
            {
              icon: "mdi-clipboard-check-outline",
              id: "presence-offline",
              title: "حضور و غیاب کلاس آنلاین",
              color: "cyan lighten-3",
              href: "presence-entries",
              permission: "form-entries.view",
            },
          ]
        },
        {
          id: "system",
          icon: "mdi-cog",
          title: "مدیریت سیستم",
          links: [
            {
              id: "log-viewer",
              title: "لوگ سیستم",
              icon: "mdi-math-log",
              permission: "app.log-viewer",
            },
            {
              id: "horizon",
              title: "صف سیستم",
              icon: "mdi-format-page-break",
              permission: "app.horizon",
            },
            {
              id: "telescope",
              title: "تلسکوپ",
              icon: "mdi-briefcase-search",
              permission: "app.telescope",
            },
            {
              id: "task-reports",
              title: "گزارش تسک‌های سیستم",
              icon: "mdi-clipboard-pulse",
            },
            {
              id: "activity-logs",
              title: "گزارش تغییرات سیستم",
              icon: "mdi-format-list-checks",
            },
          ],
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    barTitle() {
      return window.location.host.includes('my.namaamooz.ir') ? "نماآموز" : "آنلاین آکادمی"
    },
    userNameString() {
      if (
        this.user.profile?.data?.values?.firstname &&
        this.user.profile?.data?.values?.lastname
      ) {
        return (
          this.user.profile?.data?.values?.firstname +
          " " +
          this.user.profile?.data?.values?.lastname
        );
      }

      return "تکمیل پروفایل";
    },
    userAvatar() {
      return this.user.profile?.data?.values?.profile ?? false;
    },
    profileComplete() {
      return this.user.profile?.data?.values?.firstname != null;
    },
    links() {
      const profileFormIds = {
        support: 5,
      };
      const roles = this.user.roles.filter((i) =>
        Object.keys(profileFormIds).includes(i.name)
      );
      const profileFormId =
        roles && roles.length > 0
          ? profileFormIds[roles[0].name]
            ? profileFormIds[roles[0].name]
            : "1"
          : "1";
      return [
        {
          icon: "mdi-face-profile",
          text: "پروفایل من",
          href: "/me/forms/" + profileFormId,
        },
        {
          icon: "mdi-onepassword",
          text: "تغییر رمز عبور",
          href: "/me/password",
        },
        {
          icon: "mdi-exit-run",
          text: "خروج",
          href: "/logout",
        },
      ];
    },
    userGroups() {
      return this.groups
        .filter((g) =>
          g.links
            ? g.links.filter((ig) => this.isCrudAvailable(ig)).length > 0
            : this.isCrudAvailable(g)
        )
        .map((g) =>
          g.links
            ? {
              ...g,
              links: g.links
                .filter((ig) => this.isCrudAvailable(ig))
                .map((l) => ({
                  ...l,
                  extras: l.extras?.filter((x) =>
                    this.isCrudAvailable({
                      ...x,
                      permission: x.permission ? x.permission : l.id + "." + x.id,
                    })
                  ),
                })),
            }
            : {
              ...g,
            }
        );
    },
  },
  watch: {
    body() {
      this.UpdatePageContent(this.body, this.options, this.sources);
    },
  },
  mounted() {
    if (this.body) {
      this.UpdatePageContent(this.body, this.options, this.sources);
    }
  },
  methods: {
    isCrudAvailable: function (item) {
      const av = this.user.permissions.filter(
        (permString) =>
          permString.startsWith(item.permission ? item.permission : item.id) ||
          item.id.startsWith("dashboard") || item.permission?.startsWith('any')
      );
      return av.length > 0;
    },
  },
};
</script>
